import React, { useRef, useState } from "react";
import "./video.css";
import SpaceVid from "../../images/NebulaBlue.mp4";
import { BsFillPlayFill, BsPauseFill } from "react-icons/bs";

const Video = () => {
  const [playVideo, setPlayVideo] = useState(false);
  const vidRef = useRef();

  const handleVideo = () => {
    setPlayVideo((prevPlayVideo) => !prevPlayVideo);

    if (playVideo) {
      vidRef.current.pause();
    } else {
      vidRef.current.play();
    }
  };

  return (
    <div className="video">
      <video
        src={SpaceVid}
        ref={vidRef}
        type="video/mp4"
        loop
        autoPlay
        controls={false}
        muted
      />
      <div className="video-overlay" onTouchMoveCapture={handleVideo}>
        {/* <div className="video-overlay_circle">
          {playVideo ? (
            <BsPauseFill color="#fff" fontSize={30} />
          ) : (
            <BsFillPlayFill color="#fff" fontSize={30} />
          )}
        </div> */}
      </div>
    </div>
  );
};

export default Video;
